(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hb-prescripteur-body"] && !Shopify.designMode) return;
  try {
    // Bloc « j'ai un code prescripteur » : reformate le code en MAJ + nettoie
  // les espaces avant l'envoi vers /discount/<code>, puis construit l'URL
  // /discount/<code>?redirect=/ pour appliquer la remise et revenir sur la home.
  (function () {
    const form = document.querySelector('[data-hb-presc-code]');
    if (!form) return;
    const input = form.querySelector('input[name="code"]');
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const raw = (input.value || '').trim().replace(/\s+/g, '');
      if (!raw) { input.focus(); return; }
      const url = '/discount/' + encodeURIComponent(raw) + '?redirect=' + encodeURIComponent('/');
      window.location.href = url;
    });
  })();

  // Boutons « Renommer ce code » (mock pour l'aperçu, à brancher sur le
  // workflow n8n une fois la vraie page customer/account créée).
  (function () {
    document.querySelectorAll('[data-hb-rename]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const type = btn.dataset.hbRename === 'presc' ? 'prescripteur (patients)' : 'personnel';
        alert('Renommer votre code ' + type + ' — fonctionnalité disponible depuis votre compte une fois validé. Connectez-vous à votre compte HBIOMED.');
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
